// src/components/hub/work/list/SearchMessagesSection.js
import React from "react";
import { fmtCount } from "../../../shared/format";
import SearchMessageRow from "./SearchMessageRow";

// fn_work_search returns { work, messages }. The work items render via
// TaskListView (activeCache.items). This section surfaces the message hits —
// the email/thread matches that belong alongside the work items. The parent
// gates rendering on an active search with messages; this renders hidden
// entirely when empty.
const SearchMessagesSection = ({ messages, onSelectTask }) => (
  <section
    className="mt-4 rounded-lg border border-gray-200/70 bg-gray-50/50 px-3 py-2.5 dark:border-gray-700/60 dark:bg-gray-800/30"
    data-testid="search-messages-section"
  >
    <h3 className="mb-2 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
      <span>Messages</span>
      <span className="rounded-full bg-gray-200 px-1.5 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-gray-700 dark:text-gray-300">
        {fmtCount(messages.length)}
      </span>
    </h3>
    <div className="space-y-2">
      {messages.map((msg, i) => (
        <SearchMessageRow
          key={msg.id || i}
          message={msg}
          onSelectTask={onSelectTask}
        />
      ))}
    </div>
  </section>
);

export default SearchMessagesSection;
